import { motion } from "framer-motion"
import { ArrowRight } from "lucide-react"
import { useTranslation } from "react-i18next"

export default function Hero() {
  const { t } = useTranslation()

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 pt-24 pb-24 dark:bg-gray-800">
      <motion.div className="absolute top-0 left-0 w-full h-full z-10">
        <img src="/hero.webp" className="w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-black dark:opacity-50 opacity-30 z-20" />
      </motion.div>
      <motion.h1
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="text-5xl md:text-7xl font-bold text-white mb-4 z-20"
      >
        Autodoprava Chochola
      </motion.h1>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
        className="text-xl md:text-2xl text-gray-200 mb-6 max-w-xl z-20"
      >
        {t("hero.tagline")}
      </motion.p>
      <motion.a
        href="#kontakt"
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.6 }}
        whileHover={{
          scale: 1.03,
          transition: { duration: 0.2, ease: "easeInOut" },
        }}
        whileTap={{
          scale: 0.97,
          transition: { duration: 0.2, ease: "easeOut" },
        }}
        className="inline-block relative bg-white dark:bg-gray-800 text-primary dark:text-white font-semibold px-8 py-4 rounded-lg z-20 cta-glow"
      >
        <span>{t("hero.cta")}</span>
        <ArrowRight className="inline-block ml-2 w-5" />
      </motion.a>
    </section>
  )
}
